import {
  createOrganisationDtoFromAdminOrganisationModel,
  OrganisationModel,
} from "./organisation";
import {
  createPermissionDtoFromAdminPermissionModel,
  PermissionModel,
} from "./permission";
import { createRoleDtoFromAdminRoleModel, RoleModel } from "./role";
import { UserOrganisationStatusModel } from "./userOrganisationStatus";
import {
  createUserAccountDtoFromAdminUserAccountModel,
  UserAccountModel,
} from "./userAccount";
import {
  PermissionDto,
  RoleDto,
  UserOrganisationDto,
} from "@vini-wine/core-dtos";

export interface UserOrganisationModel {
  // default includes
  organisation: OrganisationModel;

  // transform
  createdAt: Date;
  isOrganisationOwner: boolean;
  isUserDefaultOrganisation: boolean;
  status: UserOrganisationStatusModel;

  // available includes
  user?: UserAccountModel;
  permissions?: PermissionModel[];
  roles?: RoleModel[];
}

export const createUserOrganisationDtoFromAdminUserOrganisationModel = (
  userOrganisation: UserOrganisationModel,
): UserOrganisationDto => {
  let permissions: PermissionDto[] | undefined = undefined;
  if (userOrganisation.permissions) {
    permissions = [];
    for (let i = 0; i < userOrganisation.permissions.length; i += 1) {
      permissions.push(
        createPermissionDtoFromAdminPermissionModel(
          userOrganisation.permissions[i],
        ),
      );
    }
  }

  let roles: RoleDto[] | undefined = undefined;
  if (userOrganisation.roles) {
    roles = [];
    for (let i = 0; i < userOrganisation.roles.length; i += 1) {
      roles.push(createRoleDtoFromAdminRoleModel(userOrganisation.roles[i]));
    }
  }

  return {
    organisation: createOrganisationDtoFromAdminOrganisationModel(
      userOrganisation.organisation,
    ),
    createdAt: userOrganisation.createdAt,
    isOrganisationOwner: userOrganisation.isOrganisationOwner,
    isUserDefaultOrganisation: userOrganisation.isUserDefaultOrganisation,
    status: userOrganisation.status,

    user: userOrganisation.user
      ? createUserAccountDtoFromAdminUserAccountModel(userOrganisation.user)
      : undefined,
    roles,
    permissions,
  };
};
